import React, { FC, useMemo, useState } from "react";
import { Pagination, Button as PdButton } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

import { TableV2 } from "~/shared/ui/TableV2";

import { getBaseStaffUploadCheckPage } from "../../../../../MOCK/baseStaff";

import s from "./EmployeeDataCheckStep.less";

interface IProps {
  onAnotherFile: () => void;
  onClose: () => void;
  onContinue: () => void;
}

const EmployeeDataCheckStep: FC<IProps> = ({
  onAnotherFile,
  onClose,
  onContinue,
}) => {
  const { t } = useTranslation();
  const [checkPage, setCheckPage] = useState(0);
  const [checkCount, setCheckCount] = useState(25);

  const checkColumns = useMemo(
    () => [
      {
        title: t("employee.fullname"),
        dataIndex: "fio",
        key: "fio",
      },
      {
        title: t("employee.checkResult"),
        dataIndex: "checkResult",
        key: "checkResult",
      },
      {
        title: t("employee.checkField"),
        dataIndex: "field",
        key: "field",
      },
      {
        title: t("employee.checkConclusion"),
        dataIndex: "conclusion",
        key: "conclusion",
      },
    ],
    [t],
  );

  const checkData = useMemo(
    () => getBaseStaffUploadCheckPage(checkPage, checkCount),
    [checkPage, checkCount],
  );

  return (
    <div className={s.wrapper}>
      <TableV2
        customRowsKey="id"
        columns={checkColumns}
        dataSource={checkData.rows}
        wrapperClassName={s.checkTable}
      />
      <Pagination
        count={checkCount}
        page={checkPage + 1}
        totalCount={checkData.total}
        onChangeCount={(value) => {
          setCheckCount(value || 25);
          setCheckPage(0);
        }}
        onChangePage={(value) => setCheckPage(Math.max(0, value - 1))}
      />
      <div className={s.footer}>
        <button type="button" className={s.anotherFile} onClick={onAnotherFile}>
          {t("employee.anotherFile")}
        </button>
        <PdButton color="secondary" size="large" onClick={onClose}>
          {t("ui.cancel")}
        </PdButton>
        <PdButton color="primary" size="large" onClick={onContinue}>
          {t("employee.continueAction")}
        </PdButton>
      </div>
    </div>
  );
};

export default EmployeeDataCheckStep;
